import {
  MarketingLayout, Eyebrow, Display, SectionTitle, FocalSentence, Body,
  PrimaryCTA, Section, Hairline,
} from "./MarketingLayout";

export default function AboutPage() {
  return (
    <MarketingLayout testid="about-page">
      <Section testid="about-hero" className="pt-24 sm:pt-32 pb-16">
        <div className="max-w-[820px]">
          <Eyebrow>About Ara</Eyebrow>
          <Display className="mt-6">
            Built for the parent holding the invisible list.
          </Display>
          <FocalSentence className="mt-8 max-w-[46ch]">
            ARA began the night someone we love finally said the list is too much.
          </FocalSentence>
        </div>
      </Section>

      <Hairline />

      <Section testid="about-story">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-x-16 gap-y-8">
          <div><Eyebrow>The story</Eyebrow></div>
          <div className="max-w-[62ch] space-y-6">
            <Body>
              In our own household, one person quietly carried everything — the
              school notices, the dentist appointments, tonight’s dinner, the
              insurance renewal, the recipes we cooked a hundred times, the
              birthdays, the tap that still drips.
            </Body>
            <Body>
              We tried spreadsheets. We tried notes apps. We tried project
              boards. Every tool made the list more visible without making
              it lighter. The mental load didn’t shrink — it just moved.
            </Body>
            <Body>
              ARA is the tool we wished someone had built. Not another
              productivity app. A quiet household operating system that
              understands rooms, not columns.
            </Body>
            <FocalSentence>
              Every room ships almost empty and grows with your family — never demanding, never guilt-tripping.
            </FocalSentence>
          </div>
        </div>
      </Section>

      <Hairline />

      <Section testid="about-values">
        <Eyebrow>What we believe</Eyebrow>
        <SectionTitle className="mt-5 max-w-[26ch]">
          Software should be quieter, not louder.
        </SectionTitle>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-14 max-w-[880px]">
          {[
            { title: "Calm over clutter",     body: "Every design decision reduces noise, not adds to it. Warm ivory, hairlines, generous whitespace." },
            { title: "Clarity over complexity", body: "Every room answers one question in under three seconds. Nothing shouts. Numbers never scream." },
            { title: "Trust through simplicity", body: "No dark patterns. No engagement metrics. No data resale. Your household is yours." },
            { title: "Naturally, warmly, timeless", body: "Built to sit alongside a family for years — not to be replaced every twelve months." },
          ].map(v => (
            <div key={v.title}>
              <p className="text-[19px] leading-[1.2] tracking-[-0.01em]" style={{ fontFamily: "var(--ara-font-display, 'Fraunces'), 'Times New Roman', serif", color: 'var(--ara-ink, #1F1F1F)', fontWeight: 400 }}>
                {v.title}
              </p>
              <Body className="mt-3 max-w-[42ch]">{v.body}</Body>
            </div>
          ))}
        </div>
      </Section>

      <Hairline />

      <Section testid="about-privacy">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_2fr] gap-x-16 gap-y-8">
          <div><Eyebrow>Privacy</Eyebrow></div>
          <div className="max-w-[62ch]">
            <SectionTitle>Your Residence is private by default.</SectionTitle>
            <Body className="mt-8">
              Only the people you invite ever see your rooms. Money and
              Documents are held behind a household PIN. Everything is
              encrypted at rest. We never sell data. We never advertise inside
              the Residence. We never train third-party AI on your family life.
            </Body>
          </div>
        </div>
      </Section>

      <Hairline />

      <Section testid="about-cta" className="pb-32 text-center">
        <SectionTitle className="max-w-[22ch] mx-auto">
          The Residence is almost ready.
        </SectionTitle>
        <Body className="mt-6 max-w-[42ch] mx-auto">
          Join the Founding Members shaping ARA as it grows.
        </Body>
        <div className="mt-10">
          <PrimaryCTA to="/join-beta">Join the waitlist →</PrimaryCTA>
        </div>
      </Section>
    </MarketingLayout>
  );
}
